import Vue from "vue";
import { mapState } from "vuex";

import actionBarComponent from "@/components/child/actionBar/actionBar.vue";
import checkboxComponent from "@/components/child/form/checkbox.vue";
import comboComponent from "@/components/child/form/combo.vue";
import moedaComponent from "@/components/child/form/moeda.vue";
import { Component } from "@/decorators";
import ConfiguracaoGatewayPagamentoModel from "@/models/configuracaoGatewayPagamentoModel";
import GatewayPagamentoProvider from "@/models/enum/financeiro/gatewayPagamentoProvider";
import UsuarioModel from "@/models/usuarioModel";
import configuracaoGatewayPagamentoService from "@/services/configuracaoGatewayPagamentoService";
import { AppState } from "@/store/store";

@Component({
    components: {
        actionBarComponent,
        checkboxComponent,
        comboComponent,
        moedaComponent,
    },
    computed: {
        ...mapState({
            usuarioLogado: (state: AppState) => state.session.usuarioLogado,
        }),
    },
})
export default class ConfiguracaoGatewayPagamentoEditComponent extends Vue {
    // State computed props
    usuarioLogado: UsuarioModel;

    gatewayPagamentoOptions: Array<Object> = [
        { text: "PagSeguro", value: GatewayPagamentoProvider.PagSeguro },
        { text: "Getnet", value: GatewayPagamentoProvider.Getnet },
    ];

    private model = new ConfiguracaoGatewayPagamentoModel();

    private async save() {
        const isValid = await this.$validator.validateAll();
        if (isValid) {
            let sucesso = false;
            try {
                this.model.franquiaId = Number(this.$route.params.id);

                if (this.model.id) {
                    sucesso = await configuracaoGatewayPagamentoService
                        .update(this.model, this.usuarioLogado.franquiaId)
                        .withLoading()
                        .resolveWithoutJSON();
                } else {
                    sucesso = await configuracaoGatewayPagamentoService
                        .insert(this.model, this.usuarioLogado.franquiaId)
                        .withLoading()
                        .resolveWithoutJSON();
                }
            } catch {}

            if (sucesso) {
                await this.$showSuccess(this.$t("__.ts.sucesso"), this.$t("__.ts.regisSalvosSucess"));
                this.$router.back();
            }
        }
    }

    private cancel() {
        this.$router.back();
    }

    private async mounted() {
        const data = await configuracaoGatewayPagamentoService.get(Number(this.$route.params.id));

        if (data) {
            this.model = data;
        }
    }
}
